import styled from "styled-components";

import { clamp } from "@styles/utils/conversion.style";
import { colors } from "@styles/vars/colors.style";
import { mq } from "@styles/vars/media-queries.style";

export const ToolsSideBySideMain = styled.section`
  position: relative;
  width: 100%;
  padding-bottom: 100px;
  background: ${colors.pastelGreen};
  color: ${colors.charcoal};

  ${mq.tabletPMax} {
    padding: 50px 0;
  }
`;

export const ToolsSideBySideWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const ToolsSideBySideMainGrid = styled.div`
  position: relative;
  width: 100%;

  ${mq.tabletPMax} {
    display: flex;
    flex-direction: column;
  }
`;

export const ToolsSideBySideLine = styled.div`
  display: none;

  ${mq.tabletL} {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 50%;
    z-index: 5;
    display: block;
    width: 1px;
    background: ${colors.charcoal};
    transform: translateX(-50%);
    transform-origin: top center;
    will-change: transform;
  }
`;

export const ToolsSideBySideItems = styled.div`
  position: relative;
  width: 100%;
`;

export const ToolsSideBySideItem = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  width: 100%;
  height: 100%;

  ${mq.tabletPMax} {
    display: flex;
    flex-direction: column;
  }
`;

export const ToolsSideBySideImage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: clamp(2rem, 5vw, 6rem);

  img {
    display: block;
    width: 100%;
    max-width: 35rem;
    aspect-ratio: 4 / 3;
    object-fit: cover;
  }

  ${mq.tabletPMax} {
    padding: 0;
    margin-bottom: 3rem;
  }
`;

export const ToolsSideBySideContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: clamp(2rem, 5vw, 8rem);

  
  p {
    ${clamp("font-size", 16, 24)};
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  ${mq.tabletPMax} {
    padding: 0;
  }
`;

export const ToolsSideBySideLinks = styled.div`
  margin-top: clamp(5rem, 10vw, 10rem);

  ${mq.tabletL} {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    ${clamp('gap', 40, 320)};
  }

  ${mq.tabletPMax} {
    margin-top: 4rem;
  }
`;

export const ToolsSideBySideLink = styled.div`
  display: block;
  text-decoration: none;
  color: inherit;
  cursor: pointer;

  .linkCont {
    display: flex;
    align-items: flex-end;
  }

  ${mq.tabletPMax} {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const ToolsSideBySideLinkImage = styled.div`
  flex: 1;
  max-width: 300px;

  img {
    display: block;
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }

  ${mq.tabletPMax} {
    max-width: 200px;
    margin: auto;
  }
`;

export const ToolsSideBySideLinkTitle = styled.div`
  flex: 1;
  padding-top: 10px;
  margin-top: 10px;
  border-top: 1px solid ${colors.charcoal};
  font-family: Signifier;
  text-align: center;

  ${clamp("font-size", 18, 28)};

  strong {
    font-family: National2;
    font-weight: 900;
  }
`;

export const ToolsSideBySideLinkArrow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  margin-bottom: 10px;
  margin-left: auto;

  svg {
    width: 100%;
    height: 100%;
  }
`;